import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import "./Listuserlist.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
// import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import Modal from "react-bootstrap/Modal";

//Import tooltip
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import ToolkitProvider from "react-bootstrap-table2-toolkit";

// const { SearchBar } = Search;

import apihostname from "services/apihostname";
import userService from "../../services/user.service";
import Modaladduser from "./Modaladduser";
import Modaledituser from "./Modaledituser";
import Modaleditpass from "./Modaleditpass";
import { toast } from "react-toastify";

function Listuserlist() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [show_add, setShow_add] = useState(false);
  const [show_edit, setShow_edit] = useState(false);
  const [show_pass, setShow_pass] = useState(false);
  const [show_delete, setShow_delete] = useState(false);
  const [row_delete, setRow_delete] = useState({});

  const [user_id, setUser_id] = useState(0);

  const [formData, setFormData] = useState({});
  const [image, setImage] = useState({ preview: null, raw: null });

  const renderTooltip = (props) => (
    <Tooltip {...props}>คลิ๊กเพื่อแก้ไขสถานะ</Tooltip>
  );

  const setEditForm = (userid) => {
    userService
      .getUserprofile(userid)
      .then((response) => {
        setFormData(response.data.user);
        setImage({
          preview:
            response.data.user.registerProfileImg != ""
              ? apihostname + response.data.user.registerProfileImg
              : "",
          raw: "",
        });
        setShow_edit(true);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    userService
      .getUserlist()
      .then((response) => {
        setData(response.data.users);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clickEdit = (row) => {
    setUser_id(row.row.user_id);
    setEditForm(row.row.user_id);
  };

  const clickEditpass = (row) => {
    setUser_id(row.row.user_id);
    setShow_pass(true);
  };

  const ConfirmDeleteuser = (props) => {
    // console.log(props);
    const hideModal = () => setShow_delete(false);
    // const [row, setRow] = useState({ user_uname: "", user_email: "" });
    // if (Object.keys(props.row).length > 0) {
    //   const { user_uname, user_email } = props.row;
    //   setRow({ user_uname: user_uname, user_email: user_email });
    // }

    const clickDelete = () => {
      userService
        .deleteUser(props.row.user_id)
        .then((response) => {
          if (response.data.success) {
            setShow_delete(false);
            // alert(response.data.message);
            var newArray = data.filter((a) => a.user_id != props.row.user_id);
            setData(newArray);
          } else {
            alert(response.data.message);
          }
        })
        .catch((error) => {
          console.error("error delete", error);
        });
    };
    return (
      <>
        <Modal show={show_delete} onHide={hideModal}>
          <Modal.Header>
            <Modal.Title>
              <p style={{ color: "red" }}>คุณต้องการลบ</p>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Username:</p>
            <p style={{ color: "red" }}>
              {props.row.user_uname ? props.row.user_uname : ""}
            </p>
            <br />
            <p>Email:</p>
            <p style={{ color: "red" }}>
              {props.row.user_email ? props.row.user_email : ""}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-warning" onClick={hideModal}>
              Close
            </button>
            <button className="btn btn-danger" onClick={clickDelete}>
              OK
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  };
  ConfirmDeleteuser.propTypes = {
    row: PropTypes.object,
  };

  const clickDeleteuser = (row) => {
    console.log(row);
    setRow_delete(row);
    setShow_delete(true);
  };

  const ActionsEdit = (row) => {
    return (
      <>
        <i
          className="bi bi-pencil custom-icon-table"
          onClick={() => clickEdit(row)}
        ></i>
        <i
          className="bi bi-key custom-icon-table"
          onClick={() => clickEditpass(row)}
        ></i>
        <i
          className="bi bi-trash custom-icon-table"
          style={{ color: "red" }}
          onClick={() => clickDeleteuser(row.row)}
        ></i>
      </>
    );
  };

  const formatForStatus = (cell, row) => {
    // const check = ["เป็น", "ไม่เป็น"];
    if (row.member_status == "True") {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-success">Active</p>
        </OverlayTrigger>
      );
    } else {
      return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          <p className="text-danger">Disable</p>
        </OverlayTrigger>
      );
    }
  };

  const actionsEdittFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const changeStatus = (body) => {
    userService
      .changeStatus(body)
      .then((res) => {
        if (res.data.success) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err));
  };
  const columns = [
    {
      text: "user_id",
      dataField: "user_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "ชื่อ",
      dataField: "user_name",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "นามสกุล",
      dataField: "user_lastname",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ชื่อผู้ใช้งาน",
      dataField: "user_uname",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "อีเมลล์",
      dataField: "user_email",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      filter: textFilter({ placeholder: "ค้นหา" }),
    },
    // {
    //   text: "โทรศัพท์",
    //   dataField: "user_phone",
    //   sort: true,
    //   // filter: textFilter({ placeholder: "ค้นหา" }),
    // },
    {
      text: "สิทธิ์",
      dataField: "user_type",
      sort: true,
      editable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      searchable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    {
      text: "สถานะ",
      dataField: "member_status",
      sort: true,
      formatter: formatForStatus,
      searchable: false,
      filter: textFilter({ placeholder: "ค้นหา" }),
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "True",
            label: "Active",
          },
          {
            value: "False",
            label: "Disable",
          },
        ],
      },
      filterValue: (cell) => {
        if (cell === "True") {
          return "Active";
        } else if (cell === "False") {
          return "Disable";
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "10%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
    // {
    //   text: "วันที่ลงทะเบียน",
    //   dataField: "created_at",
    //   sort: true,
    //   searchable: false,
    // },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      editable: false,
      formatter: actionsEdittFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  const handleClickAdd = () => {
    setShow_add(true);
  };

  if (loading) return <div id="search-results">Loading....</div>;
  if (error) return `Error :${error}`;

  return (
    <div>
      <ConfirmDeleteuser row={row_delete} />
      <Modaleditpass
        show={show_pass}
        // data={data}
        // setdata={(b) => setData(b)}
        hidden={(a) => setShow_pass(a)}
        userid={user_id}
      />
      <Modaledituser
        show={show_edit}
        data={data}
        setdata={(b) => setData(b)}
        hidden={(a) => setShow_edit(a)}
        userid={user_id}
        formdata={formData}
        image={image}
      />
      <Modaladduser
        show={show_add}
        data={data}
        setdata={(b) => setData(b)}
        hidden={(a) => setShow_add(a)}
      />
      <ToolkitProvider
        bootstrap4
        keyField="user_id"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <div className="text-left">
                <button
                  className="btn btn-primary"
                  onClick={handleClickAdd}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                >
                  เพิ่มจำนวนผู้ใช้งาน
                </button>
                {/* <SearchBar {...prop.searchProps} /> */}
              </div>
            </div>
            <hr />
            <BootstrapTable
              // bootstrap4
              // keyField="farmer_id"
              // columns={columns}
              // data={data}
              pagination={pagination}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {
                  changeStatus({ user_id: row.user_id, status: newValue });
                  console.log(oldValue);
                  console.log(newValue);
                  console.log(row);
                  console.log(column);
                  console.log("After Saving Cell!! ");
                },
              })}
              filter={filterFactory()}
              // loading={true}
              {...prop.baseProps}
              // cellEdit={cellEditFactory({
              //   mode: "click",
              //   blurToSave: true,
              //   afterSaveCell: handleChange,
              //   beforeSaveCell: beforeSaveCell,
              // })}
            />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Listuserlist;
